<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - ' + routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <p class="mb-5 text-justify">
        Ingresar número de identificación del titular de la obligación o número
        de pagare a consultar.
      </p>
      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->
      <table-component
        :data="datos"
        filtro
        :showSelectFiltro="false"
        :showFilterDates="false"
        :showFilterCedula="true"
        :showFilterPagare="true"
        @click-buscar="buscar"
        @click-event="clickEvent"
        :perPage="perPage"
      >
        <table-column
          slot="label"
          :label="'Pagaré'"
          v-bind:value="'pagare'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Modelo'"
          v-bind:value="'modelo'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Estado FGA'"
          v-bind:value="'tipo_estado'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Valor crédito'"
          v-bind:value="'valor_desembolso'"
          :filter="'numberFormat'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha de desembolso'"
          v-bind:value="'fecha_desembolso'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha de vencimiento'"
          v-bind:value="'fecha_vencimiento'"
          :customClass="'text-center'"
        ></table-column>
        <table-column slot="label" :icon="'fa'" :customClass="'text-center'">
          <table-column
            slot="icon"
            :icon="'fa fa-search-plus'"
            :class="'btn btn-sm btn-info'"
            :slug="'AmpliarInformacion'"
            :tooltip="'Ampliar información'"
          ></table-column>
          <table-column
            slot="icon"
            :icon="'fa fa-arrow-circle-o-down'"
            :class="'btn btn-sm btn-info ml-1'"
            :slug="'DescargarDesistimiento'"
            :tooltip="'Descargar desistimiento'"
            :customVisible=estadoDesestimiento
          ></table-column>
        </table-column>
        
      </table-component>

      <!-- Modal de ver productos -->
      <b-modal
        id="modal-1"
        title="Detalle consulta general"
        hide-footer
        size="xl"
      >
        <div v-if="infoGarantia.cliente" class="m-5">
          <h3 class="color-secundary">Información del cliente</h3>
          <div class="">
            <div class="container">
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <b>Nombre:</b>
                  {{ infoGarantia.cliente.nombre }}
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <b>Documento de identidad:</b>
                  {{ infoGarantia.cliente.cedula | numeric }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="infoGarantia.garantia" class="m-5">
          <h3 class="color-secundary">Información Operación</h3>
          <div class="">
            <div class="container">
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <b>Id:</b>
                  {{ infoGarantia.garantia.id | numeric }}
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <b>Número de pagaré:</b>
                  {{ infoGarantia.garantia.pagare }}
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <b>Código:</b>
                  {{ infoGarantia.garantia.convenio }}
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <b>Producto:</b>
                  {{ infoGarantia.garantia.producto }}
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <b>Modelo:</b>
                  {{ modelo }}
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <b>Plazo:</b>
                  {{ infoGarantia.garantia.plazo }}
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <b>Tarifa:</b>
                  {{ infoGarantia.garantia.porc_vsf }}
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <b>Cobertura:</b>
                  {{ infoGarantia.garantia.cobertura }} %
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <b>Valor Facturado:</b>
                  {{ infoGarantia.garantia.vsf | numberFormat }}
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <b>Número de factura:</b>
                  {{ infoGarantia.garantia.numero_factura }}
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <b>Fecha de factura:</b>
                  {{ infoGarantia.garantia.fecha_factura }}
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <b>Estado FGA:</b>
                  {{ infoGarantia.garantia.estado_garantia }}
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <b>Valor Facturado Total:</b>
                  {{ infoGarantia.garantia.vsf_real | numberFormat }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="infoGarantia.cartera.length" class="m-5">
          <h3 class="color-secundary">Información Cartera</h3>
          <div class="">
            <table-component :data="infoGarantia.cartera">
              <table-column
                slot="label"
                :label="'Saldo capital'"
                v-bind:value="'saldo_capital'"
                :customClass="'text-center'"
                :filter="'numberFormat'"
              ></table-column>
              <table-column
                slot="label"
                :label="'Saldo total'"
                v-bind:value="'saldo_total'"
                :customClass="'text-center'"
                :filter="'numberFormat'"
              ></table-column>
              <table-column
                slot="label"
                :label="'Fecha de corte'"
                v-bind:value="'fecha_corte'"
                :customClass="'text-center'"
              ></table-column>
              <table-column
                slot="label"
                :label="'Fecha inicio mora'"
                v-bind:value="'fecha_inicio_mora'"
                :customClass="'text-center'"
              ></table-column>
              <table-column
                slot="label"
                :label="'Cuotas mora'"
                v-bind:value="'num_cuotas_mora'"
                :customClass="'text-center'"
              ></table-column>
              <table-column
                slot="label"
                :label="'Fecha cancelación'"
                v-bind:value="'fecha_cancelacion'"
                :customClass="'text-center'"
              ></table-column>
              <table-column
                slot="label"
                :label="'Estado Cartera'"
                v-bind:value="'estado_operacion'"
                :customClass="'text-center'"
              ></table-column>
              <table-column
                slot="label"
                :label="'Mes cartera'"
                v-bind:value="'mes_cartera'"
                :customClass="'text-center'"
              ></table-column>
              <table-column
                slot="label"
                :label="'Valor Facturado'"
                v-bind:value="'valor_fianza'"
                :customClass="'text-center'"
                :filter="'numberFormat'"
              ></table-column>
            </table-component>
          </div>
        </div>
        <div v-if="infoGarantia.utilizaciones.length" class="m-5">
          <h3 class="color-secundary">utilizaciones</h3>
          <div class="">
            <table-component :data="infoGarantia.utilizaciones">
              <table-column
                slot="label"
                :label="'Fecha de utilizacion'"
                :value="'fecha_utilizacion'"
                :customClass="'text-center'"
              ></table-column>
              <table-column
                slot="label"
                :label="'Valor utilización'"
                v-bind:value="'valor_utilizacion'"
                :customClass="'text-center'"
                :filter="'numberFormat'"
              ></table-column>
              <table-column
                slot="label"
                :label="'Valor de servicio de fianza'"
                v-bind:value="'valor_fianza'"
                :customClass="'text-center'"
                :filter="'numberFormat'"
              ></table-column>
            </table-component>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import FileSaver from "file-saver";
import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";

export default {
  name: "SubirInformes",
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  computed: {
    routeName() {
      return this.$router.currentRoute.name;
    },
  },
  data() {
    return {
      cedula: null,
      pagare: null,
      datos: [],
      modelo: "sirve",
      infoGarantia: {
        cliente: [],
        garantia: [],
        cartera: [],
        utilizaciones: [],
      },
      estadoDesestimiento:[22, 38],
      perPage: 10,
    };
  },
  methods: {
    async buscar(params) {
      this.$store.commit("SET_LOADING", true);
      try {
        let response = await this.$store.state.api.get(
          "portal/informes/consulta_general",
          {
            params: {
              cedula: params.cedula,
              pagare: params.pagare,
              paginar: 1,
              row: this.perPage,
            },
          }
        );

        if (response.data.datos.length) {
          this.datos = response.data.datos;
        } else {
          this.datos = [];
          this.$toasted.show("No se encontraron resultados", {
            theme: "toasted-primary",
            position: "top-right",
            duration: 10000,
          });
        }
      } catch (err) {
        this.$toasted.show(
          "Lo sentimos, ocurrió un error al intentar consultar los datos",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 10000,
          }
        );
      }
      this.$store.commit("SET_LOADING", false);
    },
    async clickEvent(event, name) {
      this.$store.commit("SET_LOADING", true);
      switch (name) {
        case "AmpliarInformacion":
          try {
            this.infoGarantia = {
              cliente: [],
              garantia: [],
              cartera: [],
              utilizaciones: [],
            };
            let response = await this.$store.state.api.get(
              "portal/informes/detalle_consulta_general",
              { params: { id: event.id } }
            );
            if (response.data.datos.length) {
              this.datos.map((d) =>
                d.id === event.id ? (this.modelo = d.modelo) : ""
              );
              let data = response.data.datos[0];
              this.infoGarantia.cliente = {
                nombre: data.nombre_cliente,
                cedula: data.cedula_cliente,
              };

              this.infoGarantia.garantia = {
                id: event.id,
                convenio: data.convenio,
                fecha_vencimiento: data.fecha_vencimiento,
                producto: data.producto,
                vsf: data.vsf_pagada,
                porc_vsf: data.vsf,
                cobertura: data.cobertura,
                numero_factura: data.numero_factura,
                fecha_factura: data.fecha_factura,
                estado_garantia: data.estado_garantia,
                pagare: data.pagare,
                plazo: data.plazo,
                cedula: data.cedula,
                vsf_real: data.vsf_credito,
              };
              let estado_cartera = Array();
              (estado_cartera["V"] = "Vigente"), (estado_cartera["M"] = "Mora");
              estado_cartera["C"] = "Cancelada";
              estado_cartera["S"] = "Siniestrada";
              estado_cartera["P"] = "Prepagada";
              if (Array.isArray(data.cartera)) {
                let cartera = data.cartera;
                cartera.forEach((element) => {
                  this.infoGarantia.cartera.push({
                    saldo_capital: element.saldo_capital,
                    saldo_total: element.saldo_total,
                    fecha_corte: element.fecha_corte,
                    num_cuotas_mora: element.num_cuotas_mora,
                    fecha_cancelacion: element.fecha_cancelacion,
                    fecha_inicio_mora: element.fecha_inicio_mora,
                    estado_operacion: estado_cartera[element.estado_operacion],
                    mes_cartera: element.mes_cartera,
                    valor_fianza: element.valor_fianza
                      ? element.valor_fianza
                      : 0,
                  });
                });
              }
              if (Array.isArray(data.utilizaciones)) {
                let utilizacion = data.utilizaciones;
                utilizacion.forEach((element) => {
                  this.infoGarantia.utilizaciones.push({
                    fecha_utilizacion: element.fecha_utilizacion,
                    valor_utilizacion: element.vlr_utilizacion,
                    vsf: element.valor_fianza,
                  });
                });
              }
            }
            this.$root.$emit("bv::show::modal", "modal-1", "#btnShow");
          } catch (err) {
            this.$toasted.show(
              "Lo sentimos, ocurrió un error al intentar consultar el detalle de la operación",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              }
            );
          }
          break;
        case "DescargarDesistimiento":
          try {
            if (this.estadoDesestimiento.includes(event.estado)) {
              this.$store.commit("SET_LOADING", true);
              let response = await this.$store.state.api.post(
                "portal/informes/consulta_general_certificado_desestimiento",
                {
                  id: event.id,
                },
                { responseType: "arraybuffer" }
              );
              var blob = new Blob([response.data], {
                type: "application/pdf;charset=utf-8",
              });
              FileSaver.saveAs(blob, "Desemtimiento " + event.pagare);
              this.$toasted.show(
                "Pdf generado correctamente",
                {
                  theme: "toasted-primary",
                  position: "top-right",
                  duration: 10000,
                }
              );
            }
          } catch (errors) {
            console.log(errors);
            this.$toasted.show(
              "Ocurrió un error al intentar exportar el archivo",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              }
            );
          }
          break;
        default:
          break;
      }
      //DescargarDesistimiento
      this.$store.commit("SET_LOADING", false);
    },
  },
  mounted() {},
};
</script>
